<template>
  <div class="get-hired">
    <div class="hired my-5 m-auto shadow-lg container-fluid">
      <div class="container">
        <div class="row p-5 get-hired-width">
          <div class="col-lg-5 text-left">
            <p
              class="font-weight-bolder hired-text-color"
              style="font-size: 16px;"
            >Are you an elite team of developers?</p>
            <h4 class="hired-text-color very-bold text-capitalize">Get hired at top companies</h4>
          </div>
          <div class="col-lg-7 p-0 mt-4">
            <button
              class="btn-kovatek ctrl-size rounded mt-3 mx-3 py-2 font-weight-bold"
              style="width: 180px;"
              @click="showModal"
            >Remote Team Signup</button>

            <!--  <router-link to="/devsignup">
              <button
                class="btn-kovatek ctrl-size rounded mt-3 mx-3 py-2 font-weight-bold"
                style="width: 180px;"
              >Remote Team Signup</button>
            </router-link>-->
            <router-link to="/find-jobs">
              <button
                class="btn-kovatek ctrl-size rounded mt-3 mx-3 py-2 font-weight-bold"
                style="width: 180px"
              >Find Jobs</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div>
      <a-modal
        title="We're still at pre-beta stage"
        :visible="visible"
        @cancel="handleCancel"
        on-ok="handleOk"
      >
        <form>
          <div class="form-group">
            <label for="exampleInputEmail1">Email address</label>
            <input
              type="email"
              v-model="email"
              name="email"
              value
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
          </div>
        </form>

        <span>Be the first to know when we are live in beta.</span>

        <template slot="footer">
          <a-button key="submit" type="primary" :loading="loading" @click="handleOk">Subscribe</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "get-hired",
  data() {
    return {
      visible: false,
      loading: false
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      }
      if (validateEmail(this.email)) {
        this.loading = true;
        const config = {
          headers: {
            "Content-type": "application/json"
          }
        };
        const body = JSON.stringify({ email: this.email });
        try {
          axios.defaults.withCredentials = false;
          axios.post("https://formspree.io/mjvaprrp", body, config);
          setTimeout(() => {
            this.visible = false;
            this.loading = false;
          }, 4000);
        } catch (err) {
          this.error = err;
        }
      } else {
        alert("Please input a valid email address");
      }
    },
    handleCancel() {
      this.visible = false;
    }
  }
};
</script>
<style scoped>
.ctrl-size {
  font-size: 13px;
}
.hired {
  background-color: #c0e4d8;
}
.hired-text-color {
  color: #141d52;
}
.very-bold {
  font-weight: 900;
  text-shadow: 2px 0;
  letter-spacing: 2px;
  font-size: 20px;
}
.very-bold1 {
  font-weight: 900;
  text-shadow: 2px 0;
  letter-spacing: 2px;
  font-size: 36px;
}
.styled-btn {
  color: #fff;
  border-radius: 25px;
  outline: 0;
  transition: 0.2s;
}
.styled-btn:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
}
.btn-dev-signup {
  background: linear-gradient(to right, rgb(75, 179, 142), rgb(28, 71, 152));
  border: 0;
  font-size: 10px;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.3);
}
.btn-findjobs {
  background: linear-gradient(to right, rgb(254, 151, 22), rgb(241, 100, 45));
  border: 0;
  font-size: 10px;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.3);
}
.get-hired-width {
  width: 80%;
  margin: auto;
}
@media screen and (max-width: 991px) {
  .get-hired-width {
    width: 100%;
    margin: auto;
  }
}
@media screen and (max-width: 500px) {
}
</style>
